import { render } from "./Stat.vue?vue&type=template&id=e40adebc"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/jwbpinellas/wp-content/themes/jwb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__